export default "__VITE_ASSET__CpXBRKF5__"